<template>
  <article class="domain-annotation">
    <div class="domain-annotation__img-wrapper">
      <img src="@/shared/assets/images/info.svg" alt="" />
    </div>

    <div>
      <p class="domain-annotation__title">{{ $t('travel.success_screen.qic_domains.header') }}</p>
      <p class="domain-annotation__descr">
        {{ $t('travel.success_screen.qic_domains.annotation') }}
      </p>
    </div>
  </article>
</template>

<style lang="scss">
  @import './DomainAnnotation';
</style>
